import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthUserState } from './auth.state';
import { ErrorInterface } from '../../interfaces/general.interface';
import { UserInterface, UserRolesEnum } from '../../interfaces/user.interface';
import { AuthUserEntityInterface } from '../../interfaces/auth.interface';

export const selectLoginState =
  createFeatureSelector<AuthUserState>('authUserState');

export const selectAuthEntities = createSelector(
  selectLoginState,
  (state: AuthUserState): AuthUserEntityInterface | null => state.entity
);

export const selectAuthEntitiesUser = createSelector(
  selectLoginState,
  (state: AuthUserState): UserInterface | null => state.entity?.user ?? null
);

export const selectAuthFrontEntities = createSelector(
  selectLoginState,
  (state: AuthUserState): boolean => {
    return state.entity?.role === UserRolesEnum.receiver;
  }
);

export const selectAuthRoleEntities = createSelector(
  selectLoginState,
  (state: AuthUserState): string => {
    return state.entity?.role ? state.entity?.role : '';
  }
);

export const selectAuthBackAccountSetupEntities = createSelector(
  selectLoginState,
  (state: AuthUserState): boolean => {
    return !!state.entity?.user.accountNumber;
  }
);

export const selectAuthFrontState = createSelector(
  selectLoginState,
  (state: AuthUserState): AuthUserState => {
    return state;
  }
);

export const selectAuthError = createSelector(
  selectLoginState,
  (state: AuthUserState): boolean | ErrorInterface => state.error
);

export const selectAuthLoading = createSelector(
  selectLoginState,
  (state: AuthUserState): boolean => state.loading
);

export const selectAuthReady = createSelector(
  selectLoginState,
  (state: AuthUserState): boolean => !state.loading
);

export const selectAuthSuccess = createSelector(
  selectLoginState,
  (state: AuthUserState): boolean => state.success
);

export const selectAuthRedirectSuccess = createSelector(
  selectLoginState,
  (state: AuthUserState): 'admin' | boolean => state.redirect
);
